import { render, staticRenderFns } from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=template&id=674d8b14&scoped=true&"
import script from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=script&lang=js&"
export * from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=script&lang=js&"
import style0 from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=style&index=0&id=674d8b14&scoped=true&lang=css&"
import style1 from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d8b14",
  null
  
)

export default component.exports